<footer>
    <div class="footer-top">
        <div class="container">
            <!--LOGO-->
            <div class=" align-middle text-center">
                <img alt="EDP" class="d-inline-block logo-comercial" src="assets/images/stella-images/edp_logo_rgb_dark_neg.svg">
            </div>
            <!--LINKS ES-->
            <ul *edpConditionalRegion="'pt.edp.edponline.footer.nav.es'" class="nav footer-edp-nav flex-column flex-lg-row justify-content-center">
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green"
                        [href]="faqsLink"
                        [edpExternalLink]="faqsLink">
                            {{ "pt.edp.edponline.footer.faqs" | translate }}
                    </a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        href="{{ 'pt.edp.edponline.footer.contacts.link' | translate }}"
                        [edpExternalLink]="'pt.edp.edponline.footer.contacts.link' | translate">
                        {{ "Footer.ContactosEDP" | translate }}
                    </a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        [href]="policyLink" 
                        [edpExternalLink]="policyLink">
                            {{ "pt.edp.edponline.footer.privacy.policy" | translate }}</a>
                </li>
            </ul>
            <!--LINKS PT-->
            <ul *edpConditionalRegion="'pt.edp.edponline.footer.nav.pt'" class="nav footer-edp-nav flex-column flex-lg-row justify-content-center">
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a  class="d-flex pr-1 edp-text-electric-green"
                        href="{{ 'pt.edp.edponline.footer.edp.pt_link' | translate }}"
                        [edpExternalLink]="'pt.edp.edponline.footer.edp.pt_link' | translate"
                        [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('edp', 'pt.edp.edponline.footer.edp.pt_link' | translate)"
                    >
                            {{ "pt.edp.edponline.footer.edp.pt" | translate }}
                            <i class="icon-edponline-EDP_Online_09 pl-2" aria-hidden="true"></i>
                    </a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        href="{{ 'pt.edp.edponline.footer.lojas_agentes_link' | translate }}"
                        [edpExternalLink]="'pt.edp.edponline.footer.lojas_agentes_link' | translate">
                            {{ "pt.edp.edponline.footer.lojas_agentes" | translate }}</a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        href="{{ 'pt.edp.edponline.footer.contacts.link' | translate }}"
                        [edpExternalLink]="'pt.edp.edponline.footer.contacts.link' | translate">
                        {{ "Footer.ContactosEDP" | translate }}</a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green"
                        href="{{ 'pt.edp.edponline.footer.faqs.link' | translate }}"
                        [edpExternalLink]="'pt.edp.edponline.footer.faqs.link' | translate">
                            {{ "pt.edp.edponline.footer.faqs" | translate }}
                            <i class="icon-edponline-EDP_Online_09 pl-2" aria-hidden="true"></i>
                    </a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        href="https://particulares.cliente.edp.pt/pedidos-apoio"
                        [edpExternalLink]="'https://particulares.cliente.edp.pt/pedidos-apoio'">
                            {{ "pt.edp.edponline.footer.apoio_cliente" | translate }}</a>
                </li>
                <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a  class="d-flex pr-1 edp-text-electric-green"
                        href="{{'Footer.Reclamations.url' | translate}}"
                        [edpExternalLink]="'Footer.Reclamations.url' | translate">
                            {{'Footer.Reclamations'| translate }}
                            <i class="icon-edponline-EDP_Online_09 pl-2" aria-hidden="true"></i>
                    </a>
                </li>
                <!-- <li class="d-flex justify-content-between my-2 my-lg-0">
                    <a class="edp-text-electric-green" 
                        href="{{ 'pt.edp.edponline.footer.privacy.policy.link' | translate }}" 
                        [edpExternalLink]="'pt.edp.edponline.footer.privacy.policy.link'| translate">
                            {{ "pt.edp.edponline.footer.privacy.policy" | translate }}</a>
                </li> -->
            </ul>
            <!--POLICY-->
            <div class="footer-policy d-flex justify-content-center">
                <p class="ng-binding m-0 text-center" [innerHTML]="policyAndCookies"></p>
            </div>

        </div>
    </div>
    <div class="footer-bottom">
        <div class="container-fluid">
            <div class="row inner-footer align-items-center">
                <div class="col-lg-3 text-left py-2">
                    <!--SOCIAL MEDIA-->
                    <ul *edpConditionalRegion="'pt.edp.edponline.footer.nav.social.media.pt'" class="footer-nav-social nav justify-content-center">
                        <li *edpConditionalRegion="'pt.edp.edponline.footer.pt'">
                            <a href="https://www.youtube.com/channel/UCfDZEsM917wz2CMmAzt_ctg"
                                [edpExternalLink]="'https://www.youtube.com/channel/UCfDZEsM917wz2CMmAzt_ctg'"
                                [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('youtube', 'https://www.youtube.com/channel/UCfDZEsM917wz2CMmAzt_ctg')"
                            >
                                <span class="social-icons">
                                    <i class="fa fa-youtube-play" aria-hidden="true"></i>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/edpoficial/?hl=pt"
                                [edpExternalLink]="'https://www.instagram.com/edpoficial/?hl=pt'"
                                [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('instagram', 'https://www.instagram.com/edpoficial/?hl=pt')"
                            >
                                <span class="social-icons">
                                    <i class="fa fa-instagram" aria-hidden="true"></i>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a  href="pt.edp.edponline.footer.social.media.linkedin"
                                [edpExternalLink]="'pt.edp.edponline.footer.social.media.linkedin' | translate">
                                <span class="social-icons">
                                    <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                                </span>
                            </a>
                        </li>
                    </ul>
                    <ul *edpConditionalRegion="'pt.edp.edponline.footer.nav.social.media.es'" class="footer-nav-social nav">
                        <li>
                            <a  href="pt.edp.edponline.footer.social.media.linkedin"
                                [edpExternalLink]="'pt.edp.edponline.footer.social.media.linkedin' | translate"
                                [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('linkedin', ('pt.edp.edponline.footer.social.media.linkedin' | translate))">
                                <span class="social-icons">
                                    <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-6 py-2">
                    <p class="m-0 text-center ng-binding"> {{ 'pt.edp.edponline.footer.copyright' | translate }} </p>
                </div>
                <div *edpConditionalRegion="'pt.edp.edponline.footer.download.app'" class="col-lg-3 text-center py-2">
                    <div class="row downloadApp ng-scope">
                        <div class="col-12 cell txt"><p class="my-1 ng-binding">{{ 'Footer.Download' | translate }}</p></div>
                        <div class="w-100">
                            <div class="cell appStoreBtn d-inline-block" ng-show="vm.device.os === 'ios' || vm.device.device === 'unknown'">
                                <a  href="https://itunes.apple.com/pt/app/edp-mobile/id593277662?mt=8"
                                    [edpExternalLink]="'https://itunes.apple.com/pt/app/edp-mobile/id593277662?mt=8'"
                                    [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('apple', 'https://itunes.apple.com/pt/app/edp-mobile/id593277662?mt=8')"
                                >
                                    <img src="assets/images/app-store.svg" alt="Download on App Store" />
                                </a>
                            </div>
                            <div class="cell googlePlayBtn d-inline-block" ng-show="vm.device.os === 'android' || vm.device.device === 'unknown'">
                                <a  href="https://play.google.com/store/apps/details?id=wit.edp.edpmobile&hl=pt"
                                    [edpExternalLink]="'https://play.google.com/store/apps/details?id=wit.edp.edpmobile&hl=pt'"
                                    [gaClickDatalayer]="'clickOpenLink'" [extraGaClickDatalayer]="getClickData('google', 'https://play.google.com/store/apps/details?id=wit.edp.edpmobile&hl=pt')"
                                >
                                    <img src="assets/images/google-play.svg" alt="Download on Google Store" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</footer>